module.exports = __webpack_public_path__ + "static/media/499.00b54129.png";